import React from "react";
import PropTypes from "prop-types";
import { itemList } from "@lifepay/rc-ui-toolkit";

import {
  TRANSACTIONS_FILTERS,
  COMPANIES_FILTERS,
  MERCHANTS_FILTERS,
  TERMINALS_FILTERS,
} from "./config";

import {
  companies,
  merchants,
  terminals,
  terminalTransactions,
} from "model/gql/queries";

const CompaniesData = itemList.QueryFactory(companies);
const MerchantsData = itemList.QueryFactory(merchants);
const TerminalsData = itemList.QueryFactory(terminals);
const TransactionsData = itemList.QueryFactory(terminalTransactions);

function List(props) {
  const { children, listType, history, location, ...rest } = props;

  switch (listType) {
    case "COMPANIES":
      return (
        <itemList.List
          id={"companies"}
          key={"COMPANIES"}
          history={history}
          location={location}
          dataComponent={CompaniesData}
          filtersConfig={COMPANIES_FILTERS}
          {...rest}
        >
          {(listProps) => children(listProps)}
        </itemList.List>
      );
    case "MERCHANTS":
      return (
        <itemList.List
          id={"merchants"}
          key={"MERCHANTS"}
          history={history}
          location={location}
          dataComponent={MerchantsData}
          filtersConfig={MERCHANTS_FILTERS}
          {...rest}
        >
          {(listProps) => children(listProps)}
        </itemList.List>
      );
    case "TERMINALS":
      return (
        <itemList.List
          id={"terminals"}
          key={"TERMINALS"}
          history={history}
          location={location}
          dataComponent={TerminalsData}
          filtersConfig={TERMINALS_FILTERS}
          {...rest}
        >
          {(listProps) => children(listProps)}
        </itemList.List>
      );
    case "TRANSACTIONS":
      return (
        <itemList.List
          id={"transactions"}
          key={"TRANSACTIONS"}
          history={history}
          location={location}
          dataComponent={TransactionsData}
          filtersConfig={TRANSACTIONS_FILTERS}
          loadInitially={false}
          {...rest}
        >
          {(listProps) => children(listProps)}
        </itemList.List>
      );
    default:
      return null;
  }
}

List.displayName = "List";

List.propTypes = {
  children: PropTypes.func,
  listType: PropTypes.string,
};

List.defaultProps = {};

export default List;



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Data/List.js